import styled from 'styled-components';

export const SidebarItemContainer = styled.a<{ active: boolean }>`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  cursor: pointer;
  padding: 8px 0;
  color: ${({ active, theme }) => (active ? theme.sidebar.item.active : theme.sidebar.item.color)};
  display: block;
  text-decoration: none;
`;
